import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
// import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import handshake from "../../assets/images/handshake.svg";
import verify from "../../assets/images/verify.svg";
import group5567 from "../../assets/images/group5567.svg";
import analytics from "../../assets/images/analytics.svg";
import contact from "../../assets/images/contact.svg";
import login from "../../assets/images/login.svg";
import BrandLogos from "../../assets/images/BrandLogos.svg";
import applicationSettings from "../../assets/images/application-settings.svg";
import MuiDrawer from "@mui/material/Drawer";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { SessionService } from "../../Services/session.service";
import { PermissionList } from "../../Shared/consts/permissions";

const drawerWidth = 270;
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
interface DrawerItemProps {
  section: string | undefined;
  drawerItems: {
    key: string | number;
    text: string;
    icon: any;
    url: string;
  }[];
}
let checker = (arr: string[], target: string[]) =>
  target.every((v: string) => arr.includes(v));
export const SideBar = (props: AppBarProps) => {
  const [permissions, setPermissions] = React.useState<string[]>([]);
  let drawerKey: number = 0;
  React.useEffect(() => {
    const permissionArray = SessionService.user()?.permissions;
    setPermissions(permissionArray);
  }, []);

  const grantSectionPermission = (neededPermissions: string[], obj: any) => {
    // return checker(permissions, neededPermissions) ? obj : undefined;
    const intersection = permissions.filter((x) =>
      neededPermissions.includes(x)
    );
    return intersection.length > 0 ? obj : undefined;
  };
  const grantPermission = (permission: string, obj: any) => {
    return permissions.includes(permission) ? obj : undefined;
  };
  const drawer: DrawerItemProps[] = [
    grantSectionPermission([PermissionList.DashboardPermissions.get], {
      section: "Home",
      drawerItems: [
        grantPermission(PermissionList.DashboardPermissions.get, {
          key: ++drawerKey,
          text: "Dashboard",
          icon: analytics,
          url: "/",
        }),
        grantPermission(PermissionList.ApprovePermissions.get, {
          key: ++drawerKey,
          text: "Approve",
          icon: analytics,
          url: "/approve",
        }),
        grantPermission(PermissionList.ProjectPermissions.get, {
          key: ++drawerKey,
          text: "Properties",
          icon: verify,
          url: "/property",
        }),
        grantPermission(PermissionList.ProjectPermissions.get, {
          key: ++drawerKey,
          text: "Settings",
          icon: verify,
          url: "/settings",
        }),
      ],
    }),
    grantSectionPermission(
      [
        PermissionList.SalesPermissions.get,
        PermissionList.UserPermissions.get,
        PermissionList.PurchasePermissions.get,
        PermissionList.ProductPermissions.get,
        PermissionList.EstimatePermissions.get,
        PermissionList.TaskPermissions.get,
        PermissionList.LeadPermissions.get,
        PermissionList.ContactPermissions.get,
        PermissionList.ExpansePermissions.get,
      ],
      {
        section: "Register",
        drawerItems: [
          grantPermission(PermissionList.SalesPermissions.get, {
            key: ++drawerKey,
            text: "Sales",
            icon: handshake,
            url: "/sales",
          }),
          // {
          //   ...(
          //     permissions.includes(PermissionList.RolePermissions.get) ?
          //       { ...{ key: ++drawerKey, text: "Sales", icon: handshake, url: "/sales" } } : {}
          //   )
          // },
          grantPermission(PermissionList.UserPermissions.get, {
            key: ++drawerKey,
            text: "Employees",
            icon: handshake,
            url: "/user-role-management",
          }),
          // grantPermission(PermissionList.employeePermissions.get,),
          grantPermission(PermissionList.PurchasePermissions.get, {
            //#doubt ++drawerKey,//
            key: ++drawerKey,
            text: "Purchases",
            icon: handshake,
            url: "/purchases",
          }),
          grantPermission(PermissionList.ProductPermissions.get, {
            key: ++drawerKey,
            text: "Products",
            icon: handshake,
            url: "/products",
          }),
          grantPermission(PermissionList.EstimatePermissions.get, {
            key: ++drawerKey,
            text: "Estimates",
            icon: applicationSettings,
            url: "/estimates",
          }),
          grantPermission(PermissionList.TaskPermissions.get, {
            key: ++drawerKey,
            text: "Tasks",
            icon: verify,
            url: "/tasks",
          }),
          grantPermission(PermissionList.LeadPermissions.get, {
            key: ++drawerKey,
            text: "Leads",
            icon: group5567,
            url: "/leads",
          }),
          // {
          //   key: ++drawerKey,
          //   text: "Activity",
          //   icon: analytics,
          //   url: "/activity",
          // },
          grantPermission(PermissionList.ContactPermissions.get, {
            key: ++drawerKey,
            text: "Contact",
            icon: contact,
            url: "/contact",
          }),
          grantPermission(PermissionList.ExpansePermissions.get, {
            key: ++drawerKey,
            text: "Expense",
            icon: contact,
            url: "/expanse",
          }),
        ],
      }
    ),
    grantSectionPermission([PermissionList.PaymentPermissions.get], {
      section: "Payment",
      drawerItems: [
        grantPermission(PermissionList.PaymentPermissions.get, {
          key: ++drawerKey,
          text: "Payment",
          icon: contact,
          url: "/payment",
        }),
      ],
    }),
    grantSectionPermission([PermissionList.ActivityPermissions.get], {
      section: "Reports",
      drawerItems: [
        grantPermission(PermissionList.ActivityPermissions.get, {
          key: ++drawerKey,
          text: "Activity",
          icon: analytics,
          url: "/activity",
        }),
        grantPermission(PermissionList.ActivityPermissions.get, {
          key: ++drawerKey,
          text: "Flat Report",
          icon: analytics,
          url: "/reports",
        }),
      ],
    }),
    {
      section: "",
      drawerItems: [
        { key: ++drawerKey, text: "Register", icon: login, url: "/register" },
      ],
    },
  ];
  const pathName = window.location.pathname;

  const navigate = useNavigate();

  const redirect = (item: {
    key: number | string;
    text: string;
    icon: any;
    url: string;
  }) => {
    navigate(item.url);
  };

  const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  });

  const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(9)} + 1px)`,
    },
  });

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  return (
    <Drawer
      className={"app-drawer " + (props.open ? "" : "drawer-minimize")}
      variant="permanent"
      open={props.open}
    >
      {!props.open ? (
        <span className="brandLogo">
          <img src={BrandLogos} />
        </span>
      ) : (
        <></>
      )}
      {props.open ? (
        <Link to={"/"}>
          <Button className="tring-app-india">Tring App India</Button>
        </Link>
      ) : (
        <></>
      )}
      <List>
        {drawer.map((item) => {
          return item ? (
            <>
              {props.open ? (
                <div className="register-text">{item.section}</div>
              ) : (
                <></>
              )}
              <div className="icons side-bar-items">
                {item.drawerItems.map((drawerItem) => {
                  return drawerItem ? (
                    <ListItem
                      className={
                        pathName.includes(drawerItem.url)
                          ? drawerItem.text != "Dashboard"
                            ? "active"
                            : pathName == "/"
                            ? "active"
                            : String()
                          : String()
                      }
                      button
                      key={drawerItem.key}
                      onClick={() => redirect(drawerItem)}
                    >
                      <ListItemIcon>
                        <img src={drawerItem.icon} />
                      </ListItemIcon>
                      {props.open ? (
                        <ListItemText primary={drawerItem.text} />
                      ) : (
                        <></>
                      )}
                    </ListItem>
                  ) : (
                    <></>
                  );
                })}
              </div>
            </>
          ) : (
            <></>
          );
        })}
      </List>
    </Drawer>
  );
};
export default SideBar;
